import { IRadiolabelTemplate } from "@services/http/repositories/Radiolabels.repository";
import {
  ACTION_RADIOLABELS_TYPES,
  ActionDeleteRadiolabel,
  ActionRadiolabelsBase,
} from "./ationTypes";

interface IState {
  radiolabels: IRadiolabelTemplate[];
}

const initialState: IState = {
  radiolabels: [],
};

const reducer = (
  state = initialState,
  action: ActionRadiolabelsBase
): IState => {
  switch (action.type) {
    case ACTION_RADIOLABELS_TYPES.SET_RADIOLABELS:
      return {
        ...state,
        radiolabels: action.payload as IRadiolabelTemplate[],
      };
    case ACTION_RADIOLABELS_TYPES.DELETE_RADIOLABEL:
      const id = action.payload as ActionDeleteRadiolabel["payload"];
      return {
        ...state,
        radiolabels: state.radiolabels.filter((r) => r.Id !== id),
      };
    case ACTION_RADIOLABELS_TYPES.EDIT_RADIOLABEL:
      const index = state.radiolabels.findIndex(
        (r) => r.Id === action.payload.Id
      );

      if (index === -1) return state;

      return {
        ...state,
        radiolabels: [
          ...state.radiolabels.slice(0, index),
          action.payload,
          ...state.radiolabels.slice(index + 1),
        ],
      };
    case ACTION_RADIOLABELS_TYPES.ADD_RADIOLABEL:
      return {
        ...state,
        radiolabels: [action.payload, ...state.radiolabels],
      };

    default:
      return state;
  }
};

export default reducer;
